module.exports = __webpack_public_path__ + "img/flux-capacitor.3b18f7d7.svg";